const values = {
    HOST: 'http://localhost:8081',
    // HOST: 'https://api.alocubatravel.com',
};
export default values;
